import { makeCrudStateReducer } from "seneca-common/utils/apiStates";

import { courseStatsFetchStateConfig } from "../../../../consts";

export const courseStatsMeta = makeCrudStateReducer(
  courseStatsFetchStateConfig
);
